<div class="ir-area ir-mask th-mask">
  <form class="ir-modal th-modal" novalidate="" [formGroup]="editForm" (ngSubmit)="save(editForm.value)">
    <modal-header [plugin]="plugin" [menuModal]="menuModal"></modal-header>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div class="ir-content--modal th-content">
        <table class="ir-modal-table">
          <tr>
            <td class="margin">
              <h2>
                <span>{{ 'plugins.installation-bobst-contact.owner-type' | translate }}</span>
              </h2>
            </td>
            <td class="margin-big">
              <div class="ir-form-group">
                <input type="hidden" name="OwnerType" class="ir-form-set" formControlName="OwnerType" />
                <div class="ir-line ir-select th-select" (click)="openOwnerTypeSelector()">
                  <div class="ir-line--right">
                    <div class="ir-btn th-btn-modal--content">
                      <i class="material-icons">arrow_drop_down</i>
                    </div>
                  </div>
                  <div class="ir-line-content">
                    <span>{{
                      editForm.controls.OwnerType.value
                        ? (editForm.controls.OwnerType.value | ownerType)
                        : ('common.please-select' | translate)
                    }}</span>
                  </div>
                </div>
              </div>
            </td>
            <td></td>
          </tr>
          <tr>
            <td class="margin-big">
              <h2>
                <span>{{ 'plugins.installation-bobst-contact.team-name' | translate }}</span>
              </h2>
            </td>
            <td class="margin-big">
              <div class="ir-form-group">
                <input type="hidden" name="TechnicienId" class="ir-form-set" formControlName="TechnicienId" />
                <div class="ir-line ir-select th-select" (click)="openPeopleSelector()">
                  <div class="ir-line--right">
                    <div class="ir-btn th-btn-modal--content">
                      <i class="material-icons">arrow_drop_down</i>
                    </div>
                  </div>
                  <div class="ir-line-content">
                    <span>{{ technicien?.name || ('common.please-select' | translate) }}</span>
                  </div>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td class="margin-big">
              <h2>
                <span>{{ 'plugins.installation-bobst-contact.team' | translate }}</span>
              </h2>
            </td>
            <td class="margin-big"></td>
          </tr>
          <tbody
            formArrayName="Team"
            *ngFor="let item of teamForm.controls; let i = index"
            class="optimisation-equipment"
          >
            <ng-container [formGroupName]="i">
              <tr>
                <td class="margin-big"></td>
                <td class="th-plugin-line--remove" style="text-align: right">
                  <i class="material-icons" (click)="remove(i)">remove_circle</i>
                </td>
              </tr>
              <tr>
                <td class="margin">
                  <h2>
                    <span>{{ 'plugins.installation-bobst-contact.function' | translate }}</span>
                  </h2>
                </td>
                <td class="margin-big">
                  <div class="ir-form-group">
                    <input type="hidden" name="Function" class="ir-form-set" formControlName="Function" />
                    <div class="ir-line ir-select th-select" (click)="openFunctionSelector(i)">
                      <div class="ir-line--right">
                        <div class="ir-btn th-btn-modal--content">
                          <i class="material-icons">arrow_drop_down</i>
                        </div>
                      </div>
                      <div class="ir-line-content">
                        <span>{{
                          item.controls.Function.value
                            ? (item.controls.Function.value | function)
                            : ('common.please-select' | translate)
                        }}</span>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="margin">
                  <h2>
                    <span>{{ 'plugins.installation-bobst-contact.first-name' | translate }}</span>
                  </h2>
                </td>
                <td class="margin-big">
                  <div class="ir-form-group">
                    <input name="Name" class="ir-form-set" type="text" formControlName="Name" />
                  </div>
                </td>
              </tr>
              <tr>
                <td class="margin">
                  <h2>
                    <span>{{ 'plugins.installation-bobst-contact.last-name' | translate }}</span>
                  </h2>
                </td>
                <td class="margin-big">
                  <div class="ir-form-group">
                    <input name="LastName" class="ir-form-set" type="text" formControlName="LastName" />
                  </div>
                </td>
              </tr>
              <tr>
                <td class="margin">
                  <h2>
                    <span>{{ 'plugins.installation-bobst-contact.phone' | translate }}</span>
                  </h2>
                </td>
                <td class="margin-big">
                  <div class="ir-form-group">
                    <input
                      name="Phone"
                      placeholder="+41 21 123 45 67"
                      class="ir-form-set"
                      type="tel"
                      formControlName="Phone"
                    />
                  </div>
                </td>
              </tr>
              <tr>
                <td class="margin">
                  <h2>
                    <span>{{ 'plugins.installation-bobst-contact.email' | translate }}</span>
                  </h2>
                </td>
                <td class="margin-big">
                  <div class="ir-form-group">
                    <validation-message
                      [validationControl]="item.controls.Email"
                      [validationName]="'email'"
                      [errorMessage]="'common.email-not-valid' | translate"
                    ></validation-message>
                    <input name="Email" class="ir-form-set" type="email" formControlName="Email" />
                  </div>
                </td>
              </tr>
            </ng-container>
          </tbody>
          <tr class="th-plugin-line--add">
            <td colspan="4">
              <i class="material-icons" (click)="add()">add_circle</i>
            </td>
          </tr>
          <tr>
            <td class="margin-big">
              <h2>
                <span>{{ 'plugins.installation-bobst-contact.bobst-local-telephone' | translate }}</span>
              </h2>
            </td>
            <td class="margin-big">
              <div class="ir-form-group">
                <input
                  name="LocalOfficeTel"
                  placeholder="+41 21 123 45 67"
                  class="ir-form-set"
                  type="tel"
                  formControlName="LocalOfficeTel"
                />
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <modal-footer [editForm]="editForm" [processing]="processing"></modal-footer>
  </form>
</div>

<modal #menuModal (modalOutput)="selectMenu($event)"></modal>
<modal (modalOutput)="selectOwnerTypeMenu($event)" (modalClosed)="onOwnerTypeMenuClose()" #ownerTypeModal></modal>
<modal (modalOutput)="selectPeopleMenu($event)" (modalClosed)="onPeopleMenuClose()" #peopleModal></modal>
<modal (modalOutput)="selectFunctionMenu($event)" (modalClosed)="onFunctionMenuClose()" #functionModal></modal>
<confirm
  #pluginDeleteConfirm
  (confirmOutput)="deletePlugin()"
  [title]="'common.delete-confirmation' | translate"
  [message]="'plugins.sure-to-delete' | translate"
  [danger]="true"
></confirm>
